// „Neuer Mieter“ speichern – dieselben Schritte wie das bisherige Formular (MieterErstellenFormular):
// mieter anlegen, Kontaktkanäle, Drive-Ordner, Mieterwechsel über ordner_wechsel (beendet das
// Mietverhältnis des Vormieters am Vortag des Einzugs). Neu: Mitmieter-Verknüpfung wie im Einheiten-Formular.

import { supabase } from '../supabase/client';
import { speichereKanaele } from '../kontakt/kontaktKanaele';
import { fuehreWechselAus, legeMieterOrdnerAn, planeMieterWechsel } from '../wechsel/api';
import { heuteIso } from '../immobilien/format';
import { insertPayload, kanaeleAus, type NeuerMieterEntwurf } from './neuerMieter';

export interface AnlegenErgebnis {
  id: string;
  /** Teilschritte, die nicht geklappt haben (Mieter ist trotzdem angelegt) */
  warnungen: string[];
}

export async function legeMieterAn(e: NeuerMieterEntwurf, opts: { einheitBezeichnung: string; vormieterIds: readonly string[] }): Promise<AnlegenErgebnis> {
  const { data, error } = await supabase.from('mieter').insert(insertPayload(e, opts.einheitBezeichnung)).select('id').single();
  if (error) throw new Error(error.message);
  const id = (data as { id: string }).id;
  const warnungen: string[] = [];

  try { await speichereKanaele(supabase, 'mieter', id, kanaeleAus(e)); }
  catch (err) { warnungen.push(`E-Mail/Telefon nicht gespeichert: ${err instanceof Error ? err.message : 'Fehler'}`); }

  try { await legeMieterOrdnerAn(id); }
  catch { warnungen.push('Drive-Ordner konnte nicht angelegt werden'); }

  if (opts.vormieterIds.length > 0 && e.objektId && e.einheitId) {
    if (e.art === 'wechsel') {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        const ids = await planeMieterWechsel({
          objektId: e.objektId, einheitId: e.einheitId, altRefIds: [...opts.vormieterIds], neuRefId: id,
          faelligAm: e.mietbeginn, angelegtVon: user?.id ?? null,
        });
        // Fällig: sofort ausführen; sonst erledigt es der geplante Lauf am Einzugstag
        if (e.mietbeginn <= heuteIso()) await fuehreWechselAus(ids);
      } catch (err) {
        warnungen.push(`Mieterwechsel nicht vorgemerkt: ${err instanceof Error ? err.message : 'Fehler'}`);
      }
    } else {
      const hauptmieter = opts.vormieterIds[0];
      const { error: linkFehler } = await supabase.from('entity_links').insert({
        source_type: 'mieter', source_id: hauptmieter, target_type: 'mieter', target_id: id, link_type: 'mitmieter',
      });
      if (linkFehler) warnungen.push(`Mitmieter nicht verknüpft: ${linkFehler.message}`);
    }
  }
  return { id, warnungen };
}
